import { message } from "antd";

export function useServerMessage() {
  const [messageApi, contextHolder] = message.useMessage();

  const notify = (type, content) => {
    messageApi.open({
      key: content, // Prevents duplicates
      type,
      content,
      duration: 3,
      style: { marginTop: "20px" }
    });
  };

  return { notify, contextHolder };
}
